import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MineralFaqs = ({
  heading,
  description,
  faqs
}) => {

  const [activeIndex, setActiveIndex] =
    useState(null);

  const toggleFaq = (index) => {

    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <section className="faq-section container">

        {/* TOP */}

        <motion.div
          className="faq-top"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >

          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            {heading}
          </motion.h2>

          {description && (
            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {description}
            </motion.p>
          )}

        </motion.div>

        {/* FAQ GRID */}

        <motion.div
          className="faq-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.08,
              },
            },
          }}
        >

          {faqs.map((faq, index) => {

            const isActive =
              activeIndex === index;

            return (

              <motion.div
                className={`faq-item ${
                  isActive ? "active" : ""
                }`}
                key={index}
                variants={fadeUp}
                whileHover={{
                  y: -3,
                }}
                transition={{
                  duration: 0.2,
                }}
              >

                {/* QUESTION */}

                <button
                  className="faq-question"
                  onClick={() =>
                    toggleFaq(index)
                  }
                >

                  <h4 className="card-heading">
                    {faq.question}
                  </h4>

                  <motion.span
                    className="faq-icon"
                    animate={{
                      rotate: isActive
                        ? 180
                        : 0,
                    }}
                    transition={{
                      duration: 0.3,
                    }}
                  >
                    ⌵
                  </motion.span>

                </button>

                {/* ANSWER */}

                <AnimatePresence initial={false}>

                  {isActive && (

                    <motion.div
                      className="faq-answer-wrapper open"
                      initial={{
                        height: 0,
                        opacity: 0,
                      }}
                      animate={{
                        height: "auto",
                        opacity: 1,
                      }}
                      exit={{
                        height: 0,
                        opacity: 0,
                      }}
                      transition={{
                        duration: 0.35,
                        ease: "easeInOut",
                      }}
                      style={{
                        overflow: "hidden",
                      }}
                    >

                      <motion.div
                        className="faq-answer"
                        initial={{
                          y: -10,
                          opacity: 0,
                        }}
                        animate={{
                          y: 0,
                          opacity: 1,
                        }}
                        exit={{
                          opacity: 0,
                        }}
                        transition={{
                          delay: 0.05,
                          duration: 0.25,
                        }}
                      >

                        <p className="section-text">
                          {faq.answer}
                        </p>

                      </motion.div>

                    </motion.div>

                  )}

                </AnimatePresence>

              </motion.div>
            );
          })}

        </motion.div>

      </section>
    </>
  );
};

export default MineralFaqs;